const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export type ValidationRule =
  | { required: true; message: string }
  | { type: "email"; message: string }
  | { min: number; message: string }
  | { validator: (value: unknown) => string | undefined };

/** Runs antd-`rules`-shaped validators against a single field value, returning the first error message (if any). */
export function validateField(value: unknown, rules: ValidationRule[] = []): string | undefined {
  for (const rule of rules) {
    if ("required" in rule && !value) return rule.message;
    if ("type" in rule && rule.type === "email" && typeof value === "string" && value && !EMAIL_RE.test(value)) {
      return rule.message;
    }
    if ("min" in rule && typeof value === "string" && value.length > 0 && value.length < rule.min) {
      return rule.message;
    }
    if ("validator" in rule) {
      const error = rule.validator(value);
      if (error) return error;
    }
  }
  return undefined;
}

/** Validates a map of field values against a matching map of rules, returning only the fields with errors. */
export function validateFields<T extends Record<string, unknown>>(
  values: T,
  rulesByField: Partial<Record<keyof T, ValidationRule[]>>,
): Partial<Record<keyof T, string>> {
  const errors: Partial<Record<keyof T, string>> = {};
  for (const key in rulesByField) {
    const error = validateField(values[key], rulesByField[key]);
    if (error) errors[key] = error;
  }
  return errors;
}
